
  export default {
    name: "QuickGuideWrapper",
    props: {
      quickGuideData: {
        type: Object,
        required: false,
        default: () => {},
      },
      quickGuideContentAnchorData: {
        type: Object,
        required: false,
        default: () => {}
      },
      quickGuideBlogData: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    computed: {
      quickGuideDataObj() {
        if (this.quickGuideData) {
          return this.quickGuideData;
        }
        console.debug('quickGuideDataObj is empty');
        return {};
      }
    },
    // watch: {
    //   quickGuideData: {
    //     deep: true,
    //     handler(newVal, oldVal) {
    //       console.log('quickGuideData changed');
    //       this.quickGuideDataObj = newVal;
    //       console.log(this.quickGuideDataObj);
    //     }
    //   }
    // }
  };
  